import { NgModule } from '@angular/core';
import { I18nCurrencyPipe } from './currency.pipe';
import { I18nDecimalPipe } from './decimal.pipe';
import { I18nDurationPipe } from './duration.pipe';
import { TranslateBooleanPipe } from './translate-boolean.pipe';
import { TranslateInlinePipe } from './translate-inline.pipe';
import { TranslateWithFallbackPipe } from './translate-with-fallback.pipe';
import { TranslatePipe } from './translate.pipe';
import { I18nDatePipe } from './date.pipe';
import { I18nTimeSpanPipe } from './time-span.pipe';

const DECLARATIONS = [
  TranslateBooleanPipe,
  TranslateInlinePipe,
  TranslatePipe,
  TranslateWithFallbackPipe,
  I18nCurrencyPipe,
  I18nDecimalPipe,
];

/**
 * Module for internationalization (i18n).
 * Use this module when you want to use the i18n features in a
 * component / module.
 */
@NgModule({
  declarations: DECLARATIONS,
  imports: [I18nDurationPipe, I18nDatePipe, I18nTimeSpanPipe],
  exports: [...DECLARATIONS, I18nDurationPipe, I18nDatePipe, I18nTimeSpanPipe],
})
export class I18nModule {}
